var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#chevron-bottom-white';
                    var viewUrl = 'svg/global.svg#view-chevron-bottom-white';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 8',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };